import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/AdjustedMain.png';
import circle from '../assets/circle.png';
import logo from '../assets/prooheckcp.png';

import unity from '../assets/WhiteUnityLogo.png';
import ue4 from '../assets/UE4LogoWhite.png';
import roblox from '../assets/RobloxIcon.png';

import portuguese from '../assets/PortugueseFlag.png';
import discord from '../assets/Discord.png';

import whatsapp from '../assets/Whatsapp.png';
import gmail from '../assets/GmailLogo.png';

export default {
  discord,
  gmail,
  whatsapp,
  portuguese,
  email,
  mobile,
  api,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  unity,
  ue4,
  roblox,
};